import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const createBatchJobLog = async (object) => {
  try {
    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.createBatchJobLog, { input: object })
    );
    return response.data.createBatchJobLog;
  } catch (error) {
    console.error("Error creating BatchJobLog:", error);
    throw error;
  }
};

const updateBatchJobLog = async (id, args) => {
  try {
    // First, fetch the current version of the BatchJobLog
    const getBatchJobLogResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getBatchJobLog, { id })
    );
    const currentBatchJobLog = getBatchJobLogResponse.data.getBatchJobLog;

    // Prepare the update input
    const updateInput = { id, _version: currentBatchJobLog._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.updateBatchJobLog, { input: updateInput })
    );
    return response.data.updateBatchJobLog;
  } catch (error) {
    console.error("Error updating BatchJobLog:", error);
    throw error;
  }
};

const deleteBatchJobLog = async (id) => {
  try {
    // First, fetch the current version of the BatchJobLog
    const getBatchJobLogResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getBatchJobLog, { id })
    );
    const currentBatchJobLog = getBatchJobLogResponse.data.getBatchJobLog;

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.deleteBatchJobLog, {
        input: { id, _version: currentBatchJobLog._version },
      })
    );
    return response.data.deleteBatchJobLog;
  } catch (error) {
    console.error("Error deleting BatchJobLog:", error);
    throw error;
  }
};
const getBatchLogsByWorkspaceID = (workspaceID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.batchJobLogsByWorkspace, {
      workspaceID: workspaceID,
    })
  );

export default {
  createBatchJobLog,
  updateBatchJobLog,
  deleteBatchJobLog,
  getBatchLogsByWorkspaceID,
};
